import React from 'react';
import { Step1BasicInfo } from './Step1BasicInfo';
import { Step2Files } from './Step2Files';

import { Card } from 'primereact/card';

interface Step1InfoAndFilesProps {
    // Step 1 Props
    formData: any;
    setFormData: (data: any) => void;
    documentTypes: any[];
    isViewMode?: boolean;
    validationTriggered?: boolean;
    touchedFields?: Record<string, boolean>;
    markDirty?: () => void;
    
    // Step 2 Props
    mainFiles: any[];
    attachedFiles: any[];
    documentTypeItems: any[];
    documentTypeItemsLoading: boolean;
    documentTypeItemMeta: any;
    formTypeOptions: any[];
    filePreviews: Record<string, string>;
    previewLoading: Record<string, boolean>;
    onComputerUpload: () => void;
    onCreateGoogleFile: () => void;
    onSelectTemplate?: () => void;
    onViewFile: (file: any) => void;
    onRemoveFile: (file: any) => void;
    onItemUpload: (item: any, idx: number) => void;
    onItemMetaChange: (seqKey: string, field: string, value: any) => void;
    getFileMenuItems: (file: any) => any[];
    getAttachmentMenuItems: (file: any) => any;
    getIconByExtension: (ext: string) => { icon: string; color: string };
    getFileTypeName: (item: any) => string;
    isTemplateMode?: boolean;
    onAutoLoadTemplate?: (templateId: string) => void;
    pdfGenerating?: Set<string>;
}


export const Step1InfoAndFiles: React.FC<Step1InfoAndFilesProps> = (props) => {
    return (
        <div className="grid mt-2">
            <div className="col-12 lg:col-4 xl:col-3">
                <Card 
                    title={<span style={{ color: 'var(--text-color)', fontSize: '1.25rem', fontWeight: 'bold' }}>Thông tin tài liệu</span>} 
                    className="h-full shadow-1 border-round-xl"
                >
                    <Step1BasicInfo 
                        formData={props.formData}
                        setFormData={props.setFormData}
                        documentTypes={props.documentTypes}
                        isViewMode={props.isViewMode}
                        validationTriggered={props.validationTriggered}
                        touchedFields={props.touchedFields}
                        markDirty={props.markDirty}
                        isTemplateMode={props.isTemplateMode}
                        onAutoLoadTemplate={props.onAutoLoadTemplate}
                    />
                </Card>
            </div>
            
            <div className="col-12 lg:col-8 xl:col-9">
                <Step2Files 
                    formData={props.formData}
                    mainFiles={props.mainFiles}
                    attachedFiles={props.attachedFiles}
                    documentTypeItems={props.documentTypeItems}
                    documentTypeItemsLoading={props.documentTypeItemsLoading}
                    documentTypeItemMeta={props.documentTypeItemMeta}
                    formTypeOptions={props.formTypeOptions}
                    isViewMode={props.isViewMode}
                    filePreviews={props.filePreviews}
                    previewLoading={props.previewLoading}
                    onComputerUpload={props.onComputerUpload}
                    onCreateGoogleFile={props.onCreateGoogleFile}
                    onSelectTemplate={props.onSelectTemplate}
                    onViewFile={props.onViewFile}
                    onRemoveFile={props.onRemoveFile}
                    onItemUpload={props.onItemUpload}
                    onItemMetaChange={props.onItemMetaChange}
                    getFileMenuItems={props.getFileMenuItems}
                    getAttachmentMenuItems={props.getAttachmentMenuItems}
                    getIconByExtension={props.getIconByExtension}
                    getFileTypeName={props.getFileTypeName}
                    validationTriggered={props.validationTriggered}
                    isTemplateMode={props.isTemplateMode}
                    pdfGenerating={props.pdfGenerating}
                />
            </div>
        </div>
    );
};
